import { Link } from "react-router-dom";
import wallpaper from "../../assets/founder.png";
import './AboutFounder.css';

export const AboutFounder = () => {
    return (
        <section className="founder-section">
      <div className="founder-container">
        <div className="founder-text">
          <h2 className="founder-subtitle">ABOUT FOUNDER</h2>
          <h1 className="founder-title">Snehal Jadhav – Ghegadmal</h1>
          <p className="founder-description">
            Mrs. Snehal has a deep passion for helping people on their emotional impact which sometimes leads to significant life changes such as relationships conflict, anxiety, depression from physical or mental injury, loss and separation of a loved ones.
            Her Counselling has helped many people to heal mental & emotional wounds, they reconnected with life and are leading the desired life.
          </p>
          <div className="homebutttons">
            <Link to="/about" className="homebtn">ABOUT US</Link>
          </div>
        </div>
        <div className="founder-image">
          <img src={wallpaper} alt="Founder" />
        </div>
      </div>
    </section>
    );
};